import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function TermitesPage() {
  return <ServicePage data={servicesData.termites} />;
}
